import {
  PDF_IMPORT_REQUEST,
  PDF_IMPORT_SUCCESS,
  PDF_IMPORT_FAILURE,
  PDF_IMPORT_PROGRESS,
  PDF_FILE_SELECT,
  PDF_IMPORT_CLEAR_ERROR,
  PDF_IMPORT_RETRY,
  PDF_IMPORT_RESET
} from "state/actions/pdfImportActions";

const initialState = {
  isUploading: false,
  uploadProgress: 0,
  error: null,
  selectedFile: null,
  lastImportedId: null,
  uploadSucceeded: false
};

const pdfImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case PDF_FILE_SELECT:
      return {
        ...state,
        selectedFile: action.payload.file,
        error: null,
        uploadProgress: 0
      };

    case PDF_IMPORT_CLEAR_ERROR:
      return {
        ...state,
        error: null
      };

    case PDF_IMPORT_REQUEST:
      return {
        ...state,
        isUploading: true,
        error: null,
        uploadProgress: 0,
        lastImportedId: null,
        uploadSucceeded: false
      };

    case PDF_IMPORT_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload.progress
      };

    case PDF_IMPORT_SUCCESS:
      return {
        ...state,
        isUploading: false,
        uploadProgress: 100,
        error: null,
        uploadSucceeded: true,
        lastImportedId: action.payload?.importId || action.payload?.id || null
      };

    case PDF_IMPORT_FAILURE:
      return {
        ...state,
        isUploading: false,
        uploadProgress: 0,
        error:
          action.payload?.error ||
          action.error ||
          "Upload failed. Please try again.",
        lastImportedId: null,
        uploadSucceeded: false
      };

    case PDF_IMPORT_RETRY:
      return {
        ...state,
        error: null,
        uploadProgress: 0
      };

    case PDF_IMPORT_RESET:
      return initialState;

    default:
      return state;
  }
};

export default pdfImportReducer;
